import { Box, Dialog, Grid, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import DialogHeader from "../DialogHeader";
import { useDispatch } from "react-redux";
import { Container, Typography, Button, Paper } from "@material-ui/core";
import StyledDialog from "../../../../../common/models/Dialog";
import BackDropLoading from "../../../common/models/BackDrop";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../../containers/actions/types";

const useStyles = makeStyles((theme) => ({
  list: {
    width: "40vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      width: "80vw",
    },
  },
  backdrop: {
    "& .MuiBackdrop-root ": {
      backgroundColor: "transparent !important",
      opacity: "0 !important",
    },
  },
   backdrop: {
    "& .MuiBackdrop-root ": {
      backgroundColor: "transparent !important",
      opacity: "0 !important",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "300px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute", // Keeps buttons in place
    bottom: "20px", // Positions it near bottom
    width: "90%",
    left: "5%",
    marginTop: "300px",
  },
  warningBox: {
    marginTop: "0.5rem",
    padding: "1rem",
    border: "2px solid red",
    backgroundColor: "#fff",
    color: "red",
    fontWeight: "bold",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "4rem",
  },

  cancelButton: {
    backgroundColor: "#f5f5f5",
    color: "black",
  },
  saveButton: {
    backgroundColor: "#173072",
    color: "white",
  },
}));

const DeleteWarehouse = (props) => {
  const { warehouseDetails, handleClose,handleRefresh ,closeView} = props;
  const [formData, setFormData] = useState(warehouseDetails);
  const classes = useStyles();
  const [savedSuccessfull, setSavedSuccessfull] = useState(false); 
  const dispatch = useDispatch();

  const handleSave = () => {
    // Dispatch to show backdrop
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait...", // Show message in backdrop
    });
  
    // Simulate the API call
    setTimeout(() => {
      // Dispatch to hide backdrop after 3 seconds
      dispatch({ type: DESTROY_BACKDROP });
  
      // Show success message
      setSavedSuccessfull(true); // Show success dialog
    }, 3000);
  };
  
  const handleCancel = () => {
    handleClose();  // Close the drawer and go back to `ViewEditWarehouse`
  };
  const handleCloseSave = () => {
    setSavedSuccessfull(false);
    handleClose()
    closeView()
    handleRefresh()
    
  }
  

  return (
    <React.Fragment>
      <BackDropLoading />
      <div className={classes.list}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ padding: "1rem" }}
        >
          <Grid item xs={12}>
            <DialogHeader header={"Delete warehouse"} />
          </Grid>
          <Container maxWidth="sm">
          {/* Warehouse Name */}
          <Typography variant="h5" style={{ fontWeight: "500", marginTop: "1rem" }}>
          {formData?.warehouseName || "No Warehouse Selected"}
          </Typography>

          {/* Warning Label */}
          <Typography variant="h6" style={{ fontWeight: "500", color: "black", marginTop: "1rem" }}>
            Warning:
          </Typography>

          {/* Warning Message */}
          <Paper elevation={0} className={classes.warningBox}>
            Delete warehouse: You are deleting the warehouse. Team members will lose access to certain parts of the application. You can't reverse this process.
          </Paper>

          {/* Buttons */}
          <Box className={classes.buttonContainer}style={{marginTop: "24rem"}}>
        <Button variant="contained" color="default" size="small" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ backgroundColor: "#173072", color: "white" }}
            onClick={handleSave}
          >
            Save changes
          </Button>
        </Box>
        </Container>
        </Grid>
      </div>
      <Dialog open={savedSuccessfull} fullWidth>
                    <StyledDialog
                      icons={true}
                      handleClose={handleCloseSave}
                      title={'Warehouse Delete successfully'}
                    />
                  </Dialog>
    </React.Fragment>
  );
};

export default DeleteWarehouse;
